import React, { useState, useEffect , forwardRef} from "react";
import * as XLSX from "xlsx";
import { useDispatch } from "react-redux";
import { fetchAttachmentFile, downloadAttachmentFile ,deleteAttachmentFile} from "../../../services/audit_redux/audit_actions/AttachmentDownload.action";
import excelImg from '../../../assets/audit_assets/attachmentImg/excel_img.png';
import { GoChevronLeft ,GoChevronRight} from "react-icons/go";
import { MdDelete ,MdOutlineFileDownload} from "react-icons/md";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import Multiselect from 'multiselect-react-dropdown';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const AttachmentViewer = ({ files = [],setFiles, fileId,deletedata, onClose, height = "100vh", width = "100vw",showSnackbar,setLoading,fetchData }) => {
  const dispatch = useDispatch();
  const [index, setIndex] = useState(0);
  const [previewURL, setPreviewURL] = useState("");
  const [fileName , setFileName] = useState("");
  const [excelMode, setExcelMode] = useState(false);
  const [zoom, setZoom] = useState(1);
  const [openDeleteFileAlert, setOpenDeleteFileAlert] = useState(false);


  const getMimeType = (ext) =>
    ({
      pdf: "application/pdf",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      webp: "image/webp",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      xls: "application/vnd.ms-excel",
    }[ext] || "application/octet-stream");

  const openViewer = async (i) => {
    if (i < 0 || i >= files.length) return;
    setLoading(true)
    setIndex(i);
    setPreviewURL("");
    setExcelMode(false);
    setZoom(1);

    const filePath = files[i];
    const ext = filePath.split(".").pop().toLowerCase();
    setFileName(filePath.split(/[/\\]/).pop());
    // EXCEL → just show icon + download button
    if (["xlsx", "xls"].includes(ext)) {
      setExcelMode(true);
      setLoading(false)
      return;
    }

    // IMAGES + PDF
    try {
      const blobResp = await dispatch(fetchAttachmentFile(fileId, filePath));

      const blob = blobResp?.message?.data;
      if (!blob) {
        setPreviewURL("");
        setLoading(false)
        return;
      }

      const fileBlob = new Blob([blob], { type: getMimeType(ext) });
      const url = URL.createObjectURL(fileBlob);
      setPreviewURL(url);
      setLoading(false)
    } catch (err) {
      setPreviewURL("");
      setLoading(false)
    }
  };

  useEffect(() => {
    if (files.length > 0 && index === 0) openViewer(0);
  }, [files]);

  const ext = files[index]?.split(".").pop().toLowerCase();

  const handleDownload = async() => {
    const response = await dispatch(downloadAttachmentFile(fileId, fileName));
    if(response.success === false){
      showSnackbar(response.message || 'Download failed', 'error');
    }
  };

  const handleDeleteFile = () => {
    setOpenDeleteFileAlert(true);
  };
  
  
const handleOpenDeleteFileAlert = () => {
  setOpenDeleteFileAlert(false)
}

const handleDeleteFileAction = async() => {
  setOpenDeleteFileAlert(false)
  try {
    const response = await dispatch(deleteAttachmentFile(fileId, fileName));
    if (response.success) { 
      showSnackbar(response.data.message, "success");
      fetchData();
    } else {
      showSnackbar(response.data.message, "error");
    }
  }
  catch (err) { 
    showSnackbar('An error occurred', 'error');
    console.error(err);
    setLoading(false);
   }
  const updated = files.filter((_, i) => i !== index); 

  setFiles(updated);
  if (updated.length === 0) {
    onClose();
    return;
  }
  if (index >= updated.length) {
    setIndex(updated.length - 1);
  } else {
    setIndex(index);
  }
  
};

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width,
          height,
          background: "#fff",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <div className="d-flex justify-content-between p-2 border-bottom">
          <h5 className="m-0">Attachments</h5>

          <button className="btn btn-danger btn-sm" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* BODY */}
        <div style={{ flex: 1, overflow: "auto", padding: "10px" }}>
          {/* EXCEL MODE */}
          {excelMode && (
            <div className="text-center p-4 mt-4">
              <img
                src={excelImg}
                alt="Excel"
                width="120"
              />
              <h6 className="mt-3">{fileName}</h6>
              <button className="btn btn-primary mt-3" onClick={handleDownload}>
                Download Excel
              </button>
            </div>
          )}

          {/* PDF */}
          {ext === "pdf" && previewURL && (
            <iframe
              src={`${previewURL}`}
              width="100%"
              height="100%"
              style={{ border: "none" }}
              title="PDF"
            />
          )}

          {/* IMAGES */}
          {["jpg", "jpeg", "png", "webp"].includes(ext) && previewURL && (
            <div
            style={{
              width: "100%",
              height: "100%",
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={previewURL}
              style={{
                transform: `scale(${zoom})`,
                transition: "0.2s",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
              alt="preview"
            />
          </div>
          
            
            // <iframe
            //   src={getIframeSrc(previewURL, ext, zoom)}
            //   width="100%"
            //   height="100%"
            //   style={{ border: "none" }}
            //   title="file-viewer"
            // />
          )}

          {!previewURL && !excelMode && <p className="text-center file_display_error text-danger text-bolder"><b>This file formate is not supported</b></p>}
        </div>

        {/* FOOTER */}
        {/* <div className="d-flex justify-content-between p-2 border-top">
          <button
            className="btn btn-secondary"
            disabled={index === 0}
            onClick={() => openViewer(index - 1)}
          >
            Previous
          </button>

          <button
            className="btn btn-secondary"
            disabled={index === files.length - 1}
            onClick={() => openViewer(index + 1)}
          >
            Next
          </button>
        </div> */}
        <div className="d-flex align-items-center p-2 border-top position-relative">

          <div className="small text-muted text-truncate" style={{ maxWidth: "30%" }}>
            {files[index]?.split("/").pop()}
          </div>

          <div className="position-absolute start-50 translate-middle-x">
            <div className="d-flex align-items-center">
              <button
                className="btn btn-transparent me-3"
                disabled={index === 0}
                onClick={() => openViewer(index - 1)}
              >
                <GoChevronLeft />
              </button>

              <div className="fw-bold bg-light ps-3 rounded border-start border-dark">
                Attachments {index + 1} / {files.length}
                <button className="btn btn-sm" onClick={handleDownload}>
                  <MdOutlineFileDownload style={{ fontSize: "20px" }} />
                </button>
              </div>

              <button
                className="btn btn-transparent ms-3"
                disabled={index === files.length - 1}
                onClick={() => openViewer(index + 1)}
              >
                <GoChevronRight />
              </button>
            </div>
          </div>

          <div className="ms-auto">
            {deletedata && (
              <button
                className="btn btn-light text-danger me-4"
                onClick={handleDeleteFile}
              >
                <MdDelete style={{ fontSize: "20px" }} />
              </button>
            )}
          </div>

        </div>


      </div>
      
      <Dialog
          open={openDeleteFileAlert}
          TransitionComponent={Transition}
          keepMounted
          aria-describedby="alert-dialog-slide-description"
          sx={{ zIndex: 99999 }}
      >
          <DialogTitle>{"Are you sure?"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                  Are you sure you want to delete this {fileName}? This action cannot be undone.

              </DialogContentText>
          </DialogContent>
          <DialogActions>
              <Button onClick={handleOpenDeleteFileAlert}>No</Button>
              <Button onClick={handleDeleteFileAction}>Yes</Button>
          </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttachmentViewer;
